module.exports = __webpack_public_path__ + "media/images/doctor1-cad73bf87868ac5d15b019916d79bef0.png";